var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-flex', {
    attrs: {
      "md5": "",
      "mt-15": "",
      "xs12": "",
      "new-record": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', [_c('v-card', {
    staticStyle: {
      "padding": "50px"
    }
  }, [_c(_vm.newIcon, {
    tag: "component"
  }), _c('h3', [_vm._v(_vm._s(_vm.$t('whitelabel.myWhiteLabels')))]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('whitelabel.notFoundMessage1')) + " ")]), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function click($event) {
        return _vm.$router.push('whitelabel/create');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('whitelabel.createButton')) + " ")])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }